import React, { ReactNode } from "react";
import PageHeaderTitle from "./PageHeaderTitle";

const PageHeader = ({
  children,
  title,
}: {
  children?: ReactNode;
  title?: string | JSX.Element;
}) => {
  return (
    <div className="flex justify-between items-center w-full pb-6">
      {title && <PageHeaderTitle>{title}</PageHeaderTitle>}
      {children}
    </div>
  );
};

export default PageHeader;
